import { useTranslation } from 'react-i18next'
import { SubmitHandler, UseFormHandleSubmit } from 'react-hook-form'

import { getLocalStorageItem, setLocalStorageItem } from '@shared/utils'

import { Button, NoDigitalLoadingModal, useNoDigitalSlots } from '@shared/ui'
import { ScheduleBanner } from '../schedule-banner'
import { CarouselAgenda } from '../carousel-agenda/CarouselAgenda'

import { FORM_NAME } from '../../enums'
import { ScheduleAgendaProps, FormValues } from '../../interfaces'

interface ExtendedScheduleAgendaProps extends ScheduleAgendaProps {
  handleSubmit: UseFormHandleSubmit<FormValues>;
  onSubmit: SubmitHandler<FormValues>;
  policyId?: string;
}

export const ScheduleAgendaLayout: React.FC<ExtendedScheduleAgendaProps> = ({
  handleSubmit,
  noDigital,
  dateSelected,
  firstDateSelected,
  previousDate,
  onSubmit,
  schedules,
  buttonText,
  isMod,
  setModifyDate,
  modifyDate,
  policyId = '',
}) => {

  const { t } = useTranslation()
  const { selectedSlotData, assigningSlot } = useNoDigitalSlots({ policyId, enabled: noDigital })

  if (!schedules) return null

  if (dateSelected !== null) {
    setLocalStorageItem('dateSelected', dateSelected)
  } else {
    dateSelected = getLocalStorageItem('dateSelected')
  }

  const modifyDateAsDate = modifyDate ? new Date(modifyDate) : null

  return (
    <div className='py-9 col-start-5 col-end-13' data-testid='disposable-schedule'>
      <div className='mb-3 font-semibold text-xl leading-6 text-dark-gray'>{t('schedule.agenda.title')}</div>
      <CarouselAgenda
        dateBannerClasses='bg-modal-overlay mb-9'
        noDigital={noDigital}
        schedules={schedules}
        dateSelected={dateSelected || getLocalStorageItem('dateSelected')}
        previousDate={previousDate}
        fieldName={FORM_NAME.firstAppointmentDate}
        isMod={isMod}
        modifyDate={modifyDateAsDate}
        setModifyDate={setModifyDate}
        isSr={true}
        policyId={policyId}
      />
      {/* Banner */}
      {(() => {
        const storedDateSelected = getLocalStorageItem('dateSelected')
        const storedSlotsSelected = getLocalStorageItem('slotsSelected')
        
        const effectiveDate = dateSelected || storedDateSelected || modifyDate || firstDateSelected
        
        const shouldShowBanner = effectiveDate || (noDigital && storedSlotsSelected) || firstDateSelected
        
        console.log('🔍 SR ScheduleBanner decision:', {
          dateSelected,
          storedDateSelected,
          modifyDate,
          firstDateSelected,
          storedSlotsSelected,
          noDigital,
          isMod,
          shouldShowBanner,
          effectiveDate,
          policyHasAppointment: !!firstDateSelected
        })
        
        if (shouldShowBanner) {
          return (
            <ScheduleBanner
              dateBannerClasses='bg-modal-overlay mb-9'
              date={effectiveDate}
              appointmentDateWatched={effectiveDate}
              noDigital={noDigital}
              isMod={isMod}
            />
          )
        }
        return null
      })()}
      {/* Submit Button */}
      {(dateSelected || modifyDate || firstDateSelected || (noDigital && selectedSlotData)) && (
        <Button onClick={handleSubmit(onSubmit)}>{t(buttonText)}</Button>
      )}
      
      {/* No-digital loading modal */}
      {noDigital && assigningSlot && (
        <NoDigitalLoadingModal
          isOpen={true}
                  message={isMod ? t('common.noDigitalLoading.modifying') : t('common.noDigitalLoading.scheduling')}
        pleaseWaitMessage={t('common.noDigitalLoading.pleaseWait')}
        />
      )}
    </div>
  )
}
